import { render } from "./CourseCardComponent.vue?vue&type=template&id=2779b04e"
import script from "./CourseCardComponent.vue?vue&type=script&lang=js"
export * from "./CourseCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__